import '../../utils/index.mjs';
import Slider from './src/slider2.mjs';
export { sliderEmits, sliderProps } from './src/slider.mjs';
export { sliderContextKey } from './src/constants.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElSlider = withInstall(Slider);

export { ElSlider, ElSlider as default };
//# sourceMappingURL=index.mjs.map
